import Vue from 'vue'
import { moneyToEgg } from './egg'

Vue.filter('egg', function(value) {
  return moneyToEgg(value)
})

Vue.filter('currency', function(value, _currency, decimals) {
  value = parseInt(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  _currency = _currency != null ? _currency : '$'
  if (typeof value === 'number' && value % 1 === 0) {
    decimals = 0
  } else {
    decimals = decimals != null ? decimals : 2
  }
  // decimals = decimals != null ? decimals : 2;
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals > 0 ? stringified.slice(0, -1 - decimals) : stringified
  let i = _int.length % 3
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  let _float = decimals > 0 ? stringified.slice(-1 - decimals) : ''
  let sign = value < 0 ? '-' : ''
  let digitsRE = /(\d{3})(?=\d)/g
  return (
    sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
  )
})
Vue.filter('collectNum', function(value) {
  if (value > 9999) {
    return `${(value / 10000).toFixed(2)}万`
  } else {
    return value
  }
})
Vue.filter('date', function(value) {
  if (!value) {
    return ''
  }
  let d = new Date(value)
  let year = d.getFullYear()
  let month = '0' + (d.getMonth() + 1)
  let day = '0' + d.getDate()
  let hour = '0' + d.getHours() + ''
  let minutes = '0' + d.getMinutes() + ''
  let seconds = '0' + d.getSeconds() + ''
  return (
    year +
    '-' +
    month.substr(-2, 2) +
    '-' +
    day.substr(-2, 2) +
    ' ' +
    hour.substr(-2, 2) +
    ':' +
    minutes.substr(-2, 2) +
    ':' +
    seconds.substr(-2, 2)
  )
})
Vue.filter('diffTime', function(value) {
  if (!value) {
    return ''
  }
  //目标时间减去当前时间
  let d = new Date() - new Date(value)
  //转换成分钟
  d = d / 1000 / 60
  if (d <= 1) {
    return '1分钟前'
  }
  if (d / 60 < 1) {
    return Math.floor(d) + '分钟前'
  }
  //转换成小时
  d = d / 60
  if (d / 24 < 1) {
    return Math.floor(d) + '小时前'
  }
  //转换成天
  d = d / 24
  if (d / 30 < 1) {
    return Math.floor(d) + '天前'
  }
  //转换成月
  d = d / 30
  if (d / 12 < 1) {
    return Math.floor(d) + '个月前'
  }
  //转换成年
  d = d / 12
  return Math.floor(d) + '年前'
})
Vue.filter('offerTime', function(value) {
  if (!value) {
    return ''
  }
  value = new Date(value)
  let date = value.getDate()
  if (date < 10) {
    date = '0' + date
  }
  let hour = value.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  return 3 - date + '天' + hour + '小时'
})
//扩展字符串获取正确的长度
String.prototype.gblen = function() {
  let len = 0
  for (let i = 0; i < this.length; i++) {
    if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}
//时间字符串转换
Vue.filter('setTimeDate', function(value) {
  if (!value) {
    return ''
  }
  value = new Date(value)
  let year = value.getFullYear()
  let month = value.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  let date = value.getDate()
  if (date < 10) {
    date = '0' + date
  }
  return year + '-' + month + '-' + date
})
Vue.filter('setTimeDateText', function(value) {
  if (!value) {
    return ''
  }
  value = new Date(value)
  let year = value.getFullYear()
  let month = value.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  let date = value.getDate()
  if (date < 10) {
    date = '0' + date
  }
  return year + '年' + month + '月' + date + '号'
})
Vue.filter('setTimeDateCleacYear', function(value) {
  if (!value) {
    return ''
  }
  value = new Date(value)
  let month = value.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  let date = value.getDate()
  if (date < 10) {
    date = '0' + date
  }
  return month + '-' + date
})
Vue.filter('setTime', function(value) {
  if (!value) {
    return ''
  }
  value = new Date(value)
  let hour = value.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  let minute = value.getMinutes()
  if (minute < 10) {
    minute = '0' + minute
  }
  return hour + ':' + minute
})
Vue.filter('toFixed2', function(value) {
  if (value) {
    if (value.toString().indexOf('.') === -1) {
      return value
    } else {
      return parseFloat(
        value.toString().substring(0, value.toString().indexOf('.') + 3)
      )
    }
  }
  return value
})

Vue.filter('address', function(value) {
  if (value.split('[$]').length >= 2) {
    return value.split('[$]')[0] + value.split('[$]')[1]
  } else {
    return value
  }
})

Vue.filter('setTimeyear', function(inValue) {
  let date = new Date(inValue)
  let y = date.getFullYear()
  let m =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  return y + '-' + m + '-' + d
})

Vue.filter('moneyFormat', function(value) {
  if (!value) return 0
  if (String(value).includes('.')) {
    return Number(value).toFixed(2)
  }
  return value
})

Vue.filter('optionLabel', function(values, optionKey) {
  if (!values) return ''
  let str = ''
  for (const value of values) {
    let label = optionLabel(value, optionKey)
    if (str) {
      str += `, ${label}`
    } else {
      str += label
    }
  }
  return str
})
